import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Icon } from "../Icon/icon";
import { brandPrimaryColor } from "@optimizely/design-tokens/dist/json/colors.json";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


/**
 * Generates a `spinner` element with/without overlay and optionally
 * using props for sizes small or medium for smaller sizes.
 * @param {Object} props - Properties passed to component
 * @returns {ReactElement}
 */

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      hasOverlay = _ref.hasOverlay,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      testSection = _ref.testSection,
      props = _objectWithoutProperties(_ref, ["className", "hasOverlay", "size", "testSection"]);

  var spinner = React.createElement(Icon, _extends({
    className: classNames("axiom-spinner fa-spin-pulse", className),
    color: brandPrimaryColor,
    name: "spinner",
    size: size,
    "data-test-section": testSection
  }, props));

  if (hasOverlay) {
    return React.createElement("div", {
      "data-oui-component": true,
      "data-test-section": testSection,
      className: "oui-overlay"
    }, spinner);
  }

  return spinner;
};

Spinner.propTypes = {
  /** CSS class names. */
  className: PropTypes.string,

  /** boolean class for establish overlay */
  hasOverlay: PropTypes.bool,

  /** Various sizes. Defaults to large. */
  size: PropTypes.oneOf(["small", "medium", "large"]),

  /** Hook for automated JavaScript tests */
  testSection: PropTypes.string
};
Spinner.displayName = "Spinner";
export default Spinner;